import { api } from './client';

export interface AdminUser {
  id: string;
  username: string | null;
  full_name: string | null;
  avatar_url?: string | null;
  role: 'admin' | 'employee';
  created_at: string;
  assignments: {
    divisionId: string;
    divisionName: string;
    role: 'head' | 'content_maker' | 'editor' | 'moderator' | 'distributor';
    directions: { id: string; name: string; role: 'content_maker' | 'editor' | 'moderator' }[];
  }[];
}

export const adminApi = {
  listUsers: () =>
    api.get<{ users: AdminUser[] }>('/admin/users'),

  inviteUser: (data: { username: string; password: string; full_name?: string; role?: string }) =>
    api.post<{ success: boolean; userId: string }>('/admin/users/invite', data),

  updateUser: (id: string, data: { role?: string; full_name?: string }) =>
    api.patch<{ success: boolean }>(`/admin/users/${id}`, data),

  getAssignments: (userId: string) =>
    api.get<{ accountIds: string[] }>(`/admin/assignments/${userId}`),

  setAssignments: (userId: string, accountIds: string[]) =>
    api.put<{ success: boolean }>(`/admin/assignments/${userId}`, { accountIds }),
};
